export function findFirstDigit(value: string): number | null {
	const regex = value.match(/\d/);

	if (regex.length) {
		return parseInt(regex[0]);
	}

	return null;
}
